import { Movie, MovieJson } from '../../types/movie';
import { ImmerseCta } from '../../types/contentCta';

export function prepareMoviesData(
  moviesJson: MovieJson[],
  {
    posters,
    previews,
  }: {
    posters: Record<string, string>;
    previews?: Record<string, string>;
  },
  // eslint-disable-next-line no-console
  handleError = console.warn,
): Movie[] {
  return moviesJson.reduce((acc: Movie[], movie) => {
    previews = previews || {};

    const posterUrl = posters[movie.slug];

    if (!posterUrl) {
      handleError(`Image for "${movie.title}" is not provided`);
      return acc;
    }

    let immerseCta: ImmerseCta | null = null;

    if (movie.immerseCta) {
      const previewUrl = previews[movie.slug];

      if (previewUrl) {
        immerseCta = {
          type: 'immerse',
          previewUrl,
          ...movie.immerseCta,
        };
      } else {
        handleError(`CTA preview image for "${movie.title}" is not provided`);
      }
    }

    acc.push({ ...movie, posterUrl, immerseCta });

    return acc;
  }, []);
}
